import React from 'react';

export function LoaderCircleIcon() {
  // https://lucide.dev/icons/loader-circle
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </g>
  );
}
